import { render, staticRenderFns } from "./GenericLocation.vue?vue&type=template&id=4f0c90b4&scoped=true"
import script from "./GenericLocation.vue?vue&type=script&lang=js"
export * from "./GenericLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0c90b4",
  null
  
)

export default component.exports